import {
    setAZMFilterPath,
    setFilterPathLocationToSessionStorage,
} from "@modules/global/filter-path/filter-path-handler.ts"

setFilterPathLocationToSessionStorage("community")
setAZMFilterPath()
